import { Model } from '../parents/model';

export class StockModel extends Model {
  static ATTR_ID = 'id';

  static ATTR_NAME = 'name';

  static ATTR_STREET = 'street';

  static ATTR_CITY = 'city';

  static ATTR_POST_CODE = 'post_code';

  static ATTR_IS_ACTIVE = 'is_active';

  static ATTR_IS_DEFAULT = 'is_default';

  static ATTR_CREATED_AT = 'created_at';

  static ATTR_COUNTRY_ID = 'country_id';

  get id() {
    return this.attributes[StockModel.ATTR_ID];
  }

  get name() {
    return this.attributes[StockModel.ATTR_NAME];
  }

  get city() {
    return this.attributes[StockModel.ATTR_CITY];
  }

  get street() {
    return this.attributes[StockModel.ATTR_STREET];
  }

  get postCode() {
    return this.attributes[StockModel.ATTR_POST_CODE];
  }

  get isActive() {
    return this.attributes[StockModel.ATTR_IS_ACTIVE];
  }

  get isDefault() {
    return this.attributes[StockModel.ATTR_IS_DEFAULT];
  }

  get createdAt() {
    return this.attributes[StockModel.ATTR_CREATED_AT];
  }

  get countryId() {
    return this.attributes[StockModel.ATTR_COUNTRY_ID];
  }
}
